var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top"},[_c('appHeader',{attrs:{"showApp":""}})],1),_c('div',{staticClass:"left",style:({width:_vm.navBarWidth})},[_c('navBar')],1),_c('div',{staticClass:"main",style:({left:_vm.mainLeft})},[_c('div',{staticClass:"tag"},[_c('crumb')],1),_c('div',{staticClass:"content"},[_c('appMain')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }